import { Option } from './option';

export class Model {
    public ModelId: number;
    public ModelNumber: string;
    public ModelDescription: string;
    public DrawingNumber: string;
    public ActivStatus: string;
    public Width: number;
    public Length: number;
    public SquareFeet: number;
    public Facilities: number;
    public Bedrooms: number;
    public Bathrooms: number;
    public HUD: string;
    public Options: Option[];
    public Favorite: boolean;
    public FavoriteSort: boolean;
    public NumberOfOptions: number;
    public BasePrice: number;
    public AdjustedBasePrice: number;
    public ProductLineId: number;
    public PlantId: number;
    public BAQExcluded: boolean;

    constructor() {
        this.Options = new Array<Option>();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/model.ts